<template>
  <div class="col-xs-12">
    <div id="customers-panel" class="panel panel-primary">
      <div class="panel-heading" style="text-align: left">
        Create New Bundle Group
      </div>
      <form @submit.prevent="addBundleGroupForm">
        <div class="panel-body">
          <div v-if="bundles" class="form-group">
            <label class="control-label">Bundles*</label>

            <select
              id="bundles"
              v-model="selectBundles"
              class="form-control"
              name="bundles[]"
              multiple
              required
            >
              <option
                v-for="(product, i) in sortedBundles"
                :key="'product-' + i"
                :value="product.id"
                :data-id="product.id"
                :data-label="product.label"
                :data-group="product.group"
                :data-sub="product.has_subscription"
                :data-index="i"
                @click="handleBundleSelection($event)"
              >
                {{ product.label }}
              </option>
            </select>
            <span class="help-block">
              Select bundles to include in this group
            </span>
          </div>

          <div
            class="form-group"
            :class="nameExist ? 'has-error has-feedback' : ''"
          >
            <label class="control-label">Name*</label>
            <input
              class="form-control"
              type="text"
              name="name"
              :value="bundleName"
              required
              @change="handleBundleName"
            />
            <span
              v-if="nameExist"
              class="glyphicon glyphicon-remove form-control-feedback"
            ></span>
            <span v-if="nameExist" class="help-block">
              Please select a different Name.
            </span>
            <span class="help-block">Unique identifier for this group</span>
          </div>

          <div class="form-group">
            <label class="control-label">Label*</label>
            <input
              v-model="label"
              class="form-control"
              type="text"
              name="label"
              value=""
              required
            />
            <span class="help-block">
              Group label. Acts as the product name in the shop and product
              display blades
            </span>
          </div>

          <div v-if="locales" class="form-group">
            <label for="locale_id">Locale*</label>
            <select
              id="locale_id"
              v-model="locale_id"
              type="text"
              name="locale_id"
              class="form-control"
              required
            >
              <option
                v-for="locale in locales"
                :key="'locale_' + locale.id"
                :value="locale.id"
              >
                {{ locale.country }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  name="is_gated"
                  :checked="gateIsChecked"
                  :value="gateCheckValue"
                  @change="handleGatedChecked($event)"
                />
                Is Gated
              </label>
            </div>

            <div
              id="gated_opts"
              class="well"
              :class="gateIsChecked ? '' : 'hidden'"
            >
              <div class="row">
                <div class="form-group col-xs-12">
                  <select
                    id="gated_id"
                    v-model="gated_id"
                    class="form-control"
                    name="gated_id"
                  >
                    <option value="0">Add New...</option>
                    <option
                      v-for="gate in gates"
                      :key="'gate_' + gate.id"
                      :value="gate.id"
                    >
                      {{ gate.code }}
                    </option>
                  </select>
                </div>

                <div id="gated_select">
                  <div class="form-group col-xs-6">
                    <input
                      v-model="gated_code"
                      class="form-control"
                      type="text"
                      name="gated_code"
                      placeholder="Gated code..."
                    />
                  </div>
                  <div class="form-group col-xs-6">
                    <input
                      v-model="gated_msg"
                      class="form-control"
                      type="text"
                      name="gated_msg"
                      placeholder="Gated message..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="control-label">Description*</label>
            <textarea
              v-model="description"
              class="form-control"
              name="description"
              rows="6"
              required
            ></textarea>
            <span class="help-block">
              Main description displayed to user in the shop blade
            </span>
          </div>

          <div class="row">
            <div class="form-group col-xs-12">
              <label class="control-label">Sort Order*</label>
              <input
                v-model="sort_order"
                class="form-control"
                type="number"
                name="sort_order"
                min="0"
                step="1"
                value=""
                required
              />
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <button id="form_submit" type="submit" class="btn btn-primary">
            <span v-if="loadingSubmit === null || loadingSubmit === false">
              Submit
            </span>
            <span v-else-if="loadingSubmit === true">Processing...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale_id: 1,
      label: "",
      gated_id: 0,
      gated_code: "",
      gated_msg: "",
      description: "",
      sort_order: "",
      selectBundles: [],
    };
  },
  computed: {
    bundles() {
      return this.$store.state.bundleGroup.bundles;
    },
    gates() {
      return this.$store.state.bundleGroup.gates;
    },
    locales() {
      return this.$store.state.dic.locales;
    },
    gateIsChecked() {
      return this.$store.state.bundleGroup.gated_checked;
    },
    gateCheckValue() {
      return this.$store.state.bundleGroup.gated_checked_val;
    },
    bundleFilters() {
      return this.$store.getters.bundle_filters;
    },
    sortedBundles() {
      return this.$store.state.bundleGroup.sorted_bundles;
    },
    firstFilter() {
      return this.$store.state.bundleGroup.bundle_filters[0];
    },
    loadingSubmit() {
      return this.$store.state.bundleGroup.loading_submit;
    },
    bundleName() {
      return this.$store.state.bundleGroup.bundle_name;
    },
    nameExist() {
      return this.$store.state.bundleGroup.name_exist;
    },
  },
  created() {
    this.$store.dispatch("getBundles");
    this.$store.dispatch("getGates");
    this.$store.dispatch("getLocales", null, { root: true });
  },
  methods: {
    addBundleGroupForm() {
      const fields = this.getFields();
      this.$store.dispatch("submitForm", fields);
    },
    getFields() {
      return {
        name: this.bundleName,
        label: this.label,
        locale_id: this.locale_id,
        is_gated: this.gateCheckValue,
        gated_id: this.gated_id,
        gated_code: this.gated_code,
        gated_msg: this.gated_msg,
        description: this.description,
        sort_order: this.sort_order,
        bundles: this.selectBundles,
      };
    },
    handleGatedChecked(event) {
      this.$store.dispatch("switchGatedValue", event.target.value);
      this.$store.dispatch("setGatedChecked");
    },
    handleBundleSelection(event) {
      const { group } = event.target.dataset;
      const { sub } = event.target.dataset;
      const { index } = event.target.dataset;
      const data = { group, sub, index };

      if (this.selectBundles.length > 0) {
        this.$store.dispatch("getBundlesSorted", data);
      } else {
        this.$store.dispatch("getAllBundlesFromState");
      }
    },
    handleBundleName(event) {
      const name = event.target.value;
      this.$store.dispatch("checkForBundleName", name);
      this.$store.dispatch("setBundleName", name);
    },
  },
};
</script>
